const imgUrl = [
  require('../../assets/img/home/products.png'),
  require('../../assets/img/home/products2.png'),
  require('../../assets/img/home/物联网.png'),
  require('../../assets/img/home/视频服务-bj.png'),
  require('../../assets/img/home/智能监护bj.png'),
  require('../../assets/img/home/小人.svg'),
  require('../../assets/img/home/基站定位-bj.png'),
  require('../../assets/img/home/基站.svg')
];

export default imgUrl;
